import { ShopName } from "@/api/hooks/storeService.types";

export const $ShopNamesModuleName = "shopNames";

export type TShopNamesState = Array<ShopName>;
